<style>
@import "./consumer-reset-password.scss";
</style>
<script>
import ResetPwd from './reset-pwd/reset-pwd'
import { BTab, BTabs } from 'bootstrap-vue'

export default {
  name: 'ConsumerResetPassword',
  components: {
    ResetPwd,
    BTabs,
    BTab
  }
}
</script>

<template>
  <div
    id="config-reset-pwd"
    class="container container-height"
  >
    <div class="row mt-4">
      <div class="col">
        <h3>
          {{ $t ('header.login') }}
        </h3>
      </div>
    </div>
    <div class="border-dark border-top my-2" />
    <div class=" col-md-6 col-sm-12 mx-auto mt-3">
      <b-tabs
        content-class="password-content-wrapper"
        nav-class="account-tabs border-primary"
        justified
        lazy
      >
        <b-tab
          title="Reset Password"
          active
        >
          <reset-pwd />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
